// src/data.js
const appDetails = {
  name: "思考链条",
  tagline: "把你的思考用「树」的方式铭刻下来",
  description: "通过这一款单机ios软件，使你感受到思考的乐趣和含金量。",

  features: [
    {
      icon: "✍️",
      title: "记录与分享思考",
      text: "记录你的思考链条，使用树状图的形式展示与分享。可以添加标签和链接。",
    },
    {
      icon: "🔒",
      title: "安全保障",
      text: "数据仅存储于您的本地和 iCloud 中。你甚至可以直接全量导出为txt或pdf格式。这些功能都完全免费。",
    },
    {
      icon: "📱",
      title: "扫码互传",
      text: "对于轻量的超级链条（也就是合成若干链条后的超级链条），其他用户可在app内通过扫码的方式获取你的链条。",
    },
    {
      icon: "♾️",
      title: "轻社交",
      text: "app的世界页不定期展出用户的链条思考（额外在小红书等地征集，无隐私困扰）。",
    },
  ],
  screenshots: [
    "/pics/screenshot1.png",
    "/pics/screenshot2.png",
    "/pics/screenshot3.png",
  ],
  // 新增截图说明
  screenshotCaptions: ["简洁的主界面", "智能分类功能", "个性化设置"],
  screenshotDescriptions: [
    "一目了然的布局设计，让操作更加高效，核心功能触手可及。",
    "AI 驱动的内容分类，省去手动整理的烦恼，让信息井井有条。",
    "丰富的自定义选项，打造专属于你的使用体验，细节由你掌控。",
  ],
  qrcodes: {
    QQgroup: "/pics/qrcode_QQgroup.jpg",
  },
  downloadLinks: {
    ios: "#",
    android: "#",
  },
};

export default appDetails;

// // src/data.js
// const appDetails = {
//   name: "思考链条",
//   tagline: "把你的思考用「树」的方式铭刻下来",
//   description:
//     "这是一款有趣的ios软件，希望通过这个软件让你找到思考的乐趣和价值",
//   features: [
//     {
//       icon: "🚀",
//       title: "极速体验",
//       text: "采用先进技术，启动和运行速度飞快。",
//     },
//     {
//       icon: "🔒",
//       title: "安全保障",
//       text: "数据仅存储于您的本地和iCloud中。",
//     },
//     {
//       icon: "🤝",
//       title: "美好交互",
//       text: "无缝协作功能，让团队沟通与项目管理变得轻而易举。",
//     },
//     {
//       icon: "🧩",
//       title: "乐趣活动",
//       text: "在小红书举办活动。",
//     },
//   ],
//   screenshots: [
//     "/pics/screenshot1.png", // 使用占位图片
//     "/pics/screenshot2.png",
//     "/pics/screenshot3.png",
//   ],
//   qrcodes: {
//     QQgroup: "/pics/qrcode_QQgroup.jpg",
//   },
//   downloadLinks: {
//     ios: "#",
//     android: "#",
//   },
// };

// export default appDetails;
